import React, { useLayoutEffect, useMemo, useRef, useState } from 'react'
import { sanitizePlateInput } from '../../../helper/validatorPlateNumber'

export default function VehicleSearchCard({
  carType,
  vehicleTypes,
  vehicleIcons,
  plateNumber,
  plateError,
  canSubmit,
  onCarTypeChange,
  onPlateChange,
  onSubmit,
  onClearSelectedRecent,
  showPhoneInput,
  phoneNumber,
  phoneError,
  onPhoneChange
}) {
  const normalizePhone = (raw = '') => String(raw || '').replace(/[^\d]/g, '')
  const clear = () => onClearSelectedRecent?.()

  const items = useMemo(() => Object.entries(vehicleTypes), [vehicleTypes])
  const containerRef = useRef(null)
  const tabRefs = useRef([])
  const [indicator, setIndicator] = useState({ left: 0, width: 0 })

  const activeIndex = Math.max(
    0,
    items.findIndex(([, v]) => carType?.value === v.value)
  )

  useLayoutEffect(() => {
    const wrap = containerRef.current
    const el = tabRefs.current[activeIndex]
    if (!wrap || !el) return

    const update = () => {
      setIndicator({ left: el.offsetLeft, width: el.offsetWidth })
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [activeIndex, items.length])

  return (
    <div className="traffic-fine-search-card">
      <div className="traffic-fine-search-card-title">Thông tin xe</div>

      <div className="traffic-fine-tabs" ref={containerRef}>
        <div
          className="traffic-fine-tabs-indicator"
          style={{
            left: `${2 + indicator.left}px`,
            width: `${indicator.width}px`
          }}
        />
        {items.map(([key, v], idx) => (
          <button
            key={v.value}
            type="button"
            ref={(node) => {
              tabRefs.current[idx] = node
            }}
            className="traffic-fine-tab-item"
            onClick={() => {
              clear()
              onCarTypeChange(v)
            }}>
            <img src={vehicleIcons?.[key]} alt={v.label} />
            <span>{v.label}</span>
          </button>
        ))}
      </div>

      {showPhoneInput && (
        <div className="traffic-fine-input-group">
          <input
            className={`traffic-fine-input ${phoneError ? 'traffic-fine-input--error' : ''}`}
            placeholder="Nhập số điện thoại"
            value={phoneNumber || ''}
            type="tel"
            inputMode="numeric"
            maxLength="10"
            onChange={(e) => onPhoneChange?.(normalizePhone(e.target.value))}
            onPaste={(e) => {
              e.preventDefault()
              const text = e.clipboardData?.getData('text') || ''
              onPhoneChange?.(normalizePhone(text).slice(0, 10))
            }}
          />
          {phoneError ? (
            <div className="traffic-fine-input-error">
              <span className="traffic-fine-input-error-icon">!</span>
              <span>{phoneError}</span>
            </div>
          ) : null}
        </div>
      )}

      <div className="traffic-fine-submit-grid">
        <input
          className={`traffic-fine-input ${plateError ? 'traffic-fine-input--error' : ''}`}
          placeholder="Ví dụ: 29A12345"
          value={plateNumber}
          onChange={(e) => {
            clear()
            onPlateChange(sanitizePlateInput(e.target.value))
          }}
          onPaste={(e) => {
            e.preventDefault()
            clear()
            const text = e.clipboardData?.getData('text') || ''
            onPlateChange(sanitizePlateInput(text))
          }}
        />

        <button type="button" className="traffic-fine-submit-btn" onClick={onSubmit} disabled={!canSubmit}>
          Kiểm tra
        </button>

        <div className="traffic-fine-submit-error-line">
          {plateError ? (
            <>
              <span className="traffic-fine-input-error-icon">!</span>
              <span>{plateError}</span>
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}
